class Observable {
    static apply(target) {
        var observable = $({}),
            enabled = true;

        target.on = (event, handler) => observable.on(event, (event, ...args) => handler(...args));
        target.onNext = (event, handler) => observable.one(event, (event, ...args) => handler(...args));
        target.trigger = (...args) => observable.trigger(...args);
        target.setEventsEnabled = eventsEnabled => enabled = eventsEnabled;

        target.maybeTrigger = (...args) => {
            if (enabled) {
                observable.trigger(...args);
            }
        };

        return target;
    }

    static create() {
        return Observable.apply({});
    }
}

export default Observable;